import {newRequest} from '@/utils/request'

// 修改密码
export const updatePassword = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/admin/updatePassword', params)
